// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"O8-z"};